import { checklistsApi } from "@/lib/api";

import { createAsyncThunk } from "@reduxjs/toolkit";

import type { AuthenticatedRequestFn } from "./checklistSlice";

export const updateChecklistTemplate = createAsyncThunk(
  "checklist/updateChecklistTemplate",
  async (
    {
      id,
      title,
      description,
      tasks,
      makeRequest: _makeRequest,
    }: {
      id: number;
      title: string;
      description?: string;
      tasks: { task?: string }[];
      makeRequest?: AuthenticatedRequestFn;
    },
    { rejectWithValue }
  ) => {
    try {
      const data = await checklistsApi.updateTemplate(id, { title, description, tasks });
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : "Failed to update checklist template");
    }
  }
);
